import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import ModelActionsService from '../ModelActionsService';
import IPlatformOperatorActionsService from './IPlatformOperatorActionsService';
import { CreatePlatformOperatorRequestDTO, PlatformOperatorResponseDTO } from 'typings/dto/platformOperator';
import NavigateFrontendUtils from 'utils/NavigateFrontend';

export default class PlatformOperatorActionsServiceImpl
  extends ModelActionsService<PlatformOperator, CreatePlatformOperatorRequestDTO, PlatformOperatorResponseDTO>
  implements IPlatformOperatorActionsService
{
  /** @throws `BackendResponseError` */
  public getValuesFromOrderForFilter = (): Promise<void> => {
    const lso = NavigateFrontendUtils.getLocationSearchObjectFromCurrentLocation();
    const active = lso.active;
    const archiveYear = lso.archiveYear;
    const url = PATH_BACKEND.platformOperator.orderFilter;
    return this.getAllForFilter(undefined, { active, archiveYear }, url);
  };

  public getDefaultSortFilter = <T extends LocationSearchObject>(filter?: T): T => {
    return super.getDefaultSortFilter(filter, 'createdAt');
  };
}
